import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

export default function CommentIconPlus({ hasComments }) {
  return (
    <Icon
      link
      corner
      name="add"
      style={{
        color: hasComments ? "blue" : "#aaaaaa",
        textShadow: "none",
        position: "absolute",
        bottom: "0px",
        right: "-1px",
      }}
    />
  );
}

CommentIconPlus.propTypes = {
  hasComments: PropTypes.bool.isRequired,
};
